import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { formatMoney } from "../config/store";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedImage, setSelectedImage] = useState(0);

  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, null, null);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail-container">
      <div className="breadcrumb">
        <div className="breadcrumb-left">
          <Link to="/">Home</Link> &gt; <span>{product.category}</span> &gt;{" "}
          <span>{product.name}</span>
        </div>
      </div>

      <div className="product-detail">
        <div className="product-detail__image">
          <img
            src={product.images[selectedImage] || product.image}
            alt={product.name}
          />
          {product.images && product.images.length > 1 && (
            <div className="thumbnail-list">
              {product.images.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`${product.name} ${idx}`}
                  className={selectedImage === idx ? "active" : ""}
                  onClick={() => setImage(idx)}
                />
              ))}
            </div>
          )}
        </div>

        <div className="product-detail__info">
          <h1 className="title">{product.name}</h1>
          <p className="price">{formatMoney(product.price)}</p>

          <dl className="product-specs">
            <div><dt>Material</dt><dd>{product.material}</dd></div>
            <div><dt>Size</dt><dd>{product.size.join(", ")}</dd></div>
            <div><dt>Colour</dt><dd>{product.colors.join(", ")}</dd></div>
            <div><dt>Availability</dt><dd>{product.stock} in stock</dd></div>
          </dl>

          <div className="description">
            {product.description.map((desc, idx) => (
              <p key={idx}>{desc}</p>
            ))}
          </div>

          <ul className="features">
            {product.Features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>

          <div className="actions">
            <div className="quantity-wrapper">
              <label>Quantity</label>
              <select
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
              >
                {[...Array(10).keys()].map((x) => (
                  <option key={x + 1} value={x + 1}>
                    {x + 1}
                  </option>
                ))}
              </select>
            </div>

            <button className="btn-add-to-cart" onClick={handleAddToCart}>
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
